"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssignmentTableStudents = void 0;
const throttle_1 = __importDefault(require("lodash/throttle"));
const moment_1 = __importDefault(require("moment"));
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const react_redux_1 = require("react-redux");
const common_1 = require("../../../../../common");
const option_1 = require("../../../../../common/option");
const GlobalStateProvider_1 = require("../../../../../GlobalStateProvider");
const server_1 = require("../../../../../server");
const classes_1 = require("../../../../base/classes");
const meetmateTrust_1 = require("../../../../base/layout/meetmateTrust");
const funtions_1 = require("../../../DSTT001/funtions");
const action_1 = require("../../../../menu/action");
const constant_1 = require("../../constant");
const function_1 = require("../../function");
const AssignmentTitle_1 = require("./AssignmentTitle");
const DSTL001ListStyled_1 = require("./DSTL001ListStyled");
const CARD_GROUP_SIZE = 4;
const dateFormat = 'YYYY-MM-DD';
const progressPeriodDateTimeFormat = 'YYYY-MM-DD HH:mm';
const getProgressPeriodText = (item) => {
    const start = (0, moment_1.default)(item.startline);
    // startline 미설정/zero-date(0001, 서버 시간 처리 전)면 진행기간 미정 → '-'
    if (!item.startline || !start.isValid() || start.year() <= 1)
        return '-';
    const end = (0, moment_1.default)(item.deadline);
    // deadline 미설정/zero-date(0001-01-01, 강의 연동 전)면 종료 생략하고 시작만 표시
    const endMissing = !item.deadline || !end.isValid() || end.year() <= 1;
    if (endMissing) {
        return start.format(progressPeriodDateTimeFormat);
    }
    if (start.format(dateFormat) === end.format(dateFormat)) {
        return `${start.format(progressPeriodDateTimeFormat)} ~ ${end.format('HH:mm')}`;
    }
    return `${start.format(progressPeriodDateTimeFormat)} ~ ${end.format(progressPeriodDateTimeFormat)}`;
};
exports.AssignmentTableStudents = react_1.default.memo(({ isTest = false, isSurvey = false }) => {
    const historyStore = (0, GlobalStateProvider_1.useHistoryStore)();
    const { t } = (0, react_i18next_1.useTranslation)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const classes_data = (0, react_redux_1.useSelector)((state) => (0, classes_1.getClasses)(state));
    const { isDesktop, isTablet, isMobile, classesId } = (0, GlobalStateProvider_1.useGlobalState)();
    const listPageName = isSurvey
        ? 'surveyListPage'
        : isTest
            ? 'testListPage'
            : 'assignmentListPage';
    const [initLoad, setInitLoad] = (0, react_1.useState)(false);
    const [page, setPage] = (0, react_1.useState)(0);
    const [cardData, setCardData] = (0, react_1.useState)([]);
    const [cardGroup, setCardGroup] = (0, react_1.useState)(1);
    const [isCardLoadingMore, setIsCardLoadingMore] = (0, react_1.useState)(false);
    const [hasMoreCardData, setHasMoreCardData] = (0, react_1.useState)(false);
    const [totalCount, setTotalCount] = (0, react_1.useState)(0);
    const [hasLoadedOnce, setHasLoadedOnce] = (0, react_1.useState)(false);
    // 시작/마감 시각 경계에서 카드 상태(응시하기 활성 등)를 실시간 갱신하기 위한 tick
    const [statusTick, setStatusTick] = (0, react_1.useState)(0);
    const [status, setStatus] = (0, react_1.useState)('select');
    const [type, setType] = (0, react_1.useState)('select');
    const [keyword, setKeyword] = (0, react_1.useState)('');
    // 응시여부 필터: 'select'(전체) | 'not_submitted'(미응시) | 'submitted'(응시완료)
    const [submitted, setSubmitted] = (0, react_1.useState)('select');
    const { data, refetch, isFetching } = (0, server_1.useAssignmentList)({
        // 설문조사 목록은 assignment 필터를 걸지 않는다(survey:true 만으로 조회).
        // → 출제유형 '설문조사'로 만든 테스트(assignment:false, survey:true)도 함께 노출.
        ...(isSurvey ? {} : { assignment: !isTest }),
        // 누적 조회: 항상 offset 0 부터 '펼쳐진 전체'(=(page+1)*CARD_GROUP_SIZE)를 한 번에 조회.
        // 이렇게 하면 모든 refetch(타이머 만료·refetchInterval·REFRESH 이벤트)가 펼친 전체를
        // 신선화하므로, '더보기' 이전 페이지(1페이지) 카드의 remaining 도 함께 갱신된다.
        // (기존: offset=page*size 로 페이지마다 별도 쿼리 키 → 마지막 페이지만 재조회되어 1페이지 stale)
        offset: 0,
        limit: (page + 1) * CARD_GROUP_SIZE,
        orderby: isSurvey
            ? ['creation_time DESC']
            : isTest
                ? ['status DESC', 'creation_time DESC', 'abs(timestampdiff(minute,now(),startline))']
                : ['status DESC', 'abs(timestampdiff(minute,now(),startline))'],
        class_id: classesId,
        ...(status !== 'select' ? { status } : {}),
        survey: isSurvey,
        ...(isSurvey ? {} : type !== 'select' ? { type: t(`assignment.${type}`) } : {}),
        ...(keyword ? { keyword } : {}),
        // 응시여부: 미응시=false / 응시완료=true (서버 /api/mimac/v1/tests submitted 필터)
        ...(submitted !== 'select' ? { submitted: submitted === 'submitted' } : {}),
    });
    const refetchList = (0, throttle_1.default)(() => {
        refetch();
    }, 1000, { leading: true, trailing: false });
    (0, react_1.useEffect)(() => {
        const previousPage = historyStore.getRecentPageHistory(listPageName);
        const searchOptions = previousPage?.searchOption;
        if (searchOptions) {
            if (searchOptions.keyword !== undefined)
                setKeyword(searchOptions.keyword);
            if (searchOptions.status !== undefined)
                setStatus(searchOptions.status);
            if (searchOptions.type !== undefined)
                setType(searchOptions.type);
            if (searchOptions.submitted !== undefined)
                setSubmitted(searchOptions.submitted);
        }
        setPage(0);
        setCardGroup(1);
        setCardData([]);
        // 탭(테스트↔과제↔설문) 전환 시 이전 목록의 totalCount 가 남으면, 새 데이터 도착 전까지
        // CardTable 이 empty 문구 대신 빈 목록(+더보기)을 렌더하므로 함께 초기화한다.
        setTotalCount(0);
        setHasMoreCardData(false);
        setIsCardLoadingMore(false);
        setHasLoadedOnce(false);
        setInitLoad(true);
        return () => {
            setInitLoad(false);
            setStatus('select');
            setType('select');
            setKeyword('');
            setSubmitted('select');
        };
    }, [isTest, isSurvey, listPageName]);
    (0, react_1.useEffect)(() => {
        APP.eventManager.subscribe(constant_1.REFRESH_ASSIGNMENT_LIST, refetchList);
        return () => {
            APP.eventManager.unsubscribe(constant_1.REFRESH_ASSIGNMENT_LIST, refetchList);
        };
    }, []);
    // meetmate(별도 팝업)에서 window.opener로 보내는 메시지 수신.
    // - MIMAC_TEST_SUBMITTED: 최종 제출 → 학생 목록 즉시 재조회(submitted 반영)
    // - MIMAC_OPEN_SCORE_REPORT: 제출완료 화면 '성적표 보기' 클릭 → 해당 테스트 상세로 이동
    //   (DSSL001_Detail이 isGradeDataEntered면 자동으로 성적표 PDF 레이아웃 노출)
    (0, react_1.useEffect)(() => {
        const onMessage = (e) => {
            if (!e?.data)
                return;
            // 이 메시지(제출 알림/상세 이동)는 민감도가 낮지만 임의 출처가 화면 전환을
            // 유발할 수 있어 성적표 PDF 와 동일한 meetmateTrust 검증 정책을 적용한다.
            // 팝업 신원 레이어(우리가 window.open 으로 연 창) 덕에 어떤 환경에서도 정상 흐름은 통과한다.
            if (!(0, meetmateTrust_1.isTrustedMeetmateMessage)(e))
                return;
            if (e.data.type === 'MIMAC_TEST_SUBMITTED') {
                APP.eventManager.publish(constant_1.REFRESH_ASSIGNMENT_LIST);
            }
            else if (e.data.type === 'MIMAC_OPEN_SCORE_REPORT' && e.data.test_id) {
                dispatch((0, action_1.updateMenu)('myRoom', { menu: 'test', detail: 'detail' }, e.data.test_id));
            }
        };
        window.addEventListener('message', onMessage);
        return () => window.removeEventListener('message', onMessage);
    }, []);
    (0, react_1.useEffect)(() => {
        APP.eventManager.publish(constant_1.REFRESH_ASSIGNMENT_LIST);
    }, [classes_data?.id]);
    // remaining(개별 타이머, 초)은 '응답 수신 시점'의 스냅샷 → 수신 시각을 anchor로 기록해
    // 아래 경계 타이머에서 절대 만료시각(anchor + remaining)으로 환산한다.
    const remainingAnchorRef = (0, react_1.useRef)(0);
    (0, react_1.useEffect)(() => {
        if (data)
            remainingAnchorRef.current = Date.now();
    }, [data]);
    (0, react_1.useEffect)(() => {
        if (!data)
            return;
        setHasLoadedOnce(true);
        const { total_count, found_count, items } = data;
        if (total_count > 0 && found_count === 0) {
            const maxPage = Math.max(0, Math.ceil(total_count / CARD_GROUP_SIZE) - 1);
            if (page !== maxPage) {
                setPage(maxPage);
                return;
            }
            // 누적 조회(offset 0)라 maxPage 재조회로도 0건이면 재시도가 무의미하다
            // (서버 total_count·items 불일치 — 카운트에만 포함되고 목록에선 제외되는 항목).
            // 이때 totalCount 가 이전 값(>0)으로 남으면 empty 문구('등록된 ~가 없습니다') 대신
            // 빈 화면만 보이므로, 빈 목록으로 정리해 문구가 노출되게 한다.
            setCardData([]);
            setTotalCount(0);
            setHasMoreCardData(false);
            setIsCardLoadingMore(false);
            return;
        }
        setTotalCount(total_count);
        if (total_count > 0) {
            // 누적 조회(offset 0, limit=(page+1)*size)이므로 items 가 곧 '펼쳐진 전체'.
            // prev 에 머지하지 않고 전체 교체 → 1페이지 포함 모든 카드의 remaining 이 매 조회마다 신선화.
            const list = items.map(i => ({ ...i }));
            setCardData(list);
            setHasMoreCardData((page + 1) * CARD_GROUP_SIZE < total_count);
            setIsCardLoadingMore(false);
            return;
        }
        setCardData([]);
        setTotalCount(0);
        setHasMoreCardData(false);
        setIsCardLoadingMore(false);
    }, [data, page]);
    (0, react_1.useEffect)(() => {
        if (!initLoad)
            return;
        if (page !== 0) {
            setPage(0);
        }
        setCardGroup(1);
        setHasMoreCardData(false);
        setIsCardLoadingMore(false);
    }, [status, type, keyword, submitted, isTest, isSurvey, initLoad]);
    (0, react_1.useEffect)(() => {
        if (!initLoad || !classesId)
            return;
        // 응답이 직전 캐시와 deep-equal 이면(react-query structural sharing) data 참조가 유지되어
        // data effect 가 재실행되지 않고, 조회 실패 시에도 data 가 바뀌지 않는다 → hasLoadedOnce 가
        // false 로 남아 empty 문구('등록된 ~가 없습니다') 대신 빈 화면만 보인다.
        // 조회 시도가 끝나면(성공/실패 무관) 로드 완료로 표시해 문구가 반드시 노출되게 한다.
        refetch().finally(() => setHasLoadedOnce(true));
    }, [isTest, isSurvey, page, status, type, keyword, submitted, classesId, initLoad]);
    // 목록 조회(pending) 동안 공통 로딩 오버레이(SHOW_LOADING) 표시.
    // 더보기(증분 로드)는 자체 버튼 상태로 처리하므로 전체 오버레이에서 제외하고,
    // 언마운트 시 오버레이가 남지 않도록 해제한다.
    (0, react_1.useEffect)(() => {
        APP.eventManager.publish('SHOW_LOADING', isFetching && !isCardLoadingMore);
        return () => {
            APP.eventManager.publish('SHOW_LOADING', false);
        };
    }, [isFetching, isCardLoadingMore]);
    // 카드의 다음 상태 전환 경계(시작/마감)까지 타이머를 걸어, 응시 시간이 되면
    // 자동으로 재렌더(상태 재계산) + 서버 동기화하여 버튼/뱃지가 실시간 갱신되도록 한다.
    (0, react_1.useEffect)(() => {
        if (!cardData || cardData.length === 0)
            return;
        const now = Date.now();
        let nearest = Infinity;
        cardData.forEach(item => {
            const start = (0, moment_1.default)(item.startline);
            if (start.isValid() && start.valueOf() > now) {
                nearest = Math.min(nearest, start.valueOf());
            }
            // zero-date(0001-01-01, 강의 연동 전) 마감은 미설정으로 취급하고 startline+duration 으로
            // 대체한다 — isTestPeriodEnded 와 동일 기준(경계 시각과 상태 판정이 어긋나지 않도록).
            let end = (0, moment_1.default)(item.deadline);
            if ((!end.isValid() || end.year() <= 1) && start.isValid() && start.year() > 1) {
                const dur = Number(item.duration);
                end = start.clone().add(Number.isFinite(dur) && dur > 0 ? dur : 0, 'minutes');
            }
            // 응시완료된 강대K/이감형(grade_report=true) 카드는 마감 시각에 화면이 바뀌지 않으므로
            // ('성적처리중' 유지 — 전환은 has_report 도착 시) 마감 경계를 걸지 않는다.
            // 대신 서버 통계처리가 마감 약 1분 뒤 완료되는 것에 맞춰 '마감+1분'에 재조회하고,
            // 그때도 has_report 가 없으면(처리 지연) 30초 간격으로 재시도한다.
            // (마감 후 10분까지만 — 통계처리 실패 시 무한 폴링 방지, 이후엔 다음 자연 조회에서 반영)
            const isAwaitingReport = item.submitted === true && item.grade_report && end.isValid();
            if (isAwaitingReport) {
                if (!item.has_report && now - end.valueOf() < 10 * 60 * 1000) {
                    const statsReadyAt = end.valueOf() + 60 * 1000;
                    nearest = Math.min(nearest, Math.max(statsReadyAt, now + 30 * 1000));
                }
            }
            else if (end.isValid() && end.valueOf() > now) {
                // 마감 경계: 미응시(응시하기→응시종료)·기타 테스트(마감 시 성적표 일괄 노출) 전환용
                nearest = Math.min(nearest, end.valueOf());
            }
            // 68p: 개별 타이머(remaining, 초)가 진행 중(>0)이면 만료 시점도 경계에 포함 → 만료 시 자동 재조회로
            // /tests 가 remaining=0 을 응답 → 응시종료가 새로고침 없이 반영된다.
            // 단, 응시완료(submitted) 카드는 제외 — 서버가 제출 시점에 멈춘 타이머의 잔여값을
            // 양수로 계속 내려주는데, 만료돼도 UI가 바뀌지 않으므로(이미 응시완료) 재조회할 이유가 없다.
            const remaining = Number(item.remaining);
            if (item.submitted !== true && Number.isFinite(remaining) && remaining > 0) {
                // 수신 시각(anchor) 기준 절대 만료시각으로 환산한다. now 기준으로 더하면 statusTick
                // 재실행 때마다 항상 미래가 되어, 응답이 안 바뀌는 한 무한 refetch 루프에 빠진다.
                // (만료시각이 지났으면 start/deadline처럼 경계에서 제외)
                const expiry = remainingAnchorRef.current + remaining * 1000;
                if (expiry > now) {
                    nearest = Math.min(nearest, expiry);
                }
            }
        });
        if (!Number.isFinite(nearest))
            return;
        // +1s 버퍼, setTimeout 최대치(약 24.8일) 클램프
        const delay = Math.min(Math.max(nearest - now + 1000, 0), 2 ** 31 - 1);
        const timer = setTimeout(() => {
            setStatusTick(t => t + 1); // 재렌더 → calculateActualStatus 재계산(즉시 반영)
            refetch(); // 서버 status/enterable 동기화
        }, delay);
        return () => clearTimeout(timer);
    }, [cardData, statusTick]);
    const goToDetailPage = (id) => {
        const historyItem = {
            preItems: {},
            props: {
                isHome: false,
                isTest,
                isReserve: false,
                isReserveRegist: false,
                conference_id: undefined,
            },
            prePage: page,
            searchOption: { keyword, status, type, submitted },
            pageName: listPageName,
        };
        historyStore.pushHistory(historyItem);
        dispatch((0, action_1.updateMenu)(isSurvey ? 'learningSupportRoom' : 'myRoom', {
            menu: isSurvey ? 'survey' : isTest ? 'test' : 'assignment',
            detail: 'detail',
        }, id));
    };
    const getStudentCardState = (item) => {
        // 서버 status가 현재 시각과 어긋날 수 있어 시작일/마감일 기준으로 재계산
        // (created/open/closed 만 재계산, 특수상태는 보존)
        const actualStatus = (0, function_1.calculateActualStatus)(item);
        // 서버: enterable=true → 연결된 강의가 입장 가능 시간(시작 전 입장창 포함)
        // 응시 버튼 활성 조건 = status open 이거나 enterable=true (서버 contract)
        const isEnterable = item.enterable === true;
        // p42: 강의실 강제 종료 시 status=closed (enterable=true 여도) → 응시 불가(응시종료로 표시)
        const canTake = actualStatus !== constant_1.TEST_STATUS.CLOSED && (actualStatus === constant_1.TEST_STATUS.OPEN || isEnterable);
        // 68p: 개별 타이머 남은 시간(/tests remaining, 초). 진행중(open)·미응시라도 remaining===0 이면
        // 타이머가 종료된 것 → 더 이상 응시 불가(응시종료). remaining===-1(타이머 미생성) 또는 >0(시간 남음)이면 응시 가능.
        const timerEnded = item.remaining === 0;
        // ① 시작 전: 시작 시각(startline) 이전이면 '시작 전'(비활성).
        // 단, 서버 enterable=true 면 사전 입장 기간(pre_entering_duration) 도달이므로
        // 비활성 분기를 건너뛰고 ③ 진행중_미응시(응시하기 활성)로 넘긴다.
        if (actualStatus === constant_1.TEST_STATUS.CREATED && !isEnterable) {
            return {
                badgeText: t('assignment.created'),
                badgeClass: 'created',
                buttonText: isSurvey ? t('assignment.participate') : t('assignment.takeTest'),
                buttonClass: 'btn_light_grey',
                action: 'none',
                isVisualDisabled: true,
            };
        }
        // ② 응시완료 (submitted)
        if (item.submitted === true) {
            if (isSurvey) {
                return {
                    badgeText: t('assignment.participated'),
                    badgeClass: 'completed',
                    buttonText: t('assignment.viewSurveyResponse'),
                    buttonClass: 'btn_default',
                    action: 'detail',
                    isVisualDisabled: false,
                };
            }
            if (isTest) {
                // 테스트버튼정책(유형별 성적표 노출 시점):
                // - 강대모의고사K/이감(강사 성적입력형, grade_report=true): 성적 입력 완료
                //   (isGradeDataEntered = has_report ‖ report_data_saved 유효) 시 진행중에도 즉시 '성적표 보기'.
                // - 기타 모의고사(자동처리형, grade_report=false): 진행중엔 '성적처리중',
                //   테스트 응시 기간(마감일시) 종료 후에만 '성적표 보기'.
                //   ※ 강의실 강제종료(status=closed)로는 노출하지 않는다 — 응시 기간이 실제로 끝나야(deadline 경과) 일괄 노출.
                const reportReady = item.grade_report
                    ? !!item.has_report
                    : (0, function_1.isTestPeriodEnded)(item);
                if (reportReady) {
                    return {
                        badgeText: t('assignment.stareCompleted'),
                        badgeClass: 'completed',
                        buttonText: t('common.viewReportCard'),
                        buttonClass: 'btn_default',
                        action: 'detail',
                        isVisualDisabled: false,
                    };
                }
                // p43: 성적데이터(Excel) 미업로드면 진행중·종료 무관 '성적처리중' 표시.
                // (업로드되면 위 reportReady 분기에서 진행중이라도 즉시 '성적표 보기')
                return {
                    badgeText: t('assignment.stareCompleted'),
                    badgeClass: 'completed',
                    buttonText: t('assignment.gradeProcessing'),
                    buttonClass: 'btn_light_grey',
                    action: 'none',
                    isVisualDisabled: true,
                };
            }
            // 과제 응시완료
            return {
                badgeText: t('assignment.stareCompleted'),
                badgeClass: 'completed',
                buttonText: t('assignment.viewResult'),
                buttonClass: 'btn_default',
                action: 'detail',
                isVisualDisabled: false,
            };
        }
        // ③ 진행중_미응시 (status open 이거나 입장창 enterable)
        if (canTake && !timerEnded) {
            return {
                badgeText: isSurvey ? t('assignment.notParticipated') : t('assignment.noStare'),
                badgeClass: 'not-submitted',
                buttonText: isSurvey ? t('assignment.participate') : t('assignment.takeTest'),
                buttonClass: 'btn_pink',
                // 강의 연결 설문(survey-poll: conference_id 有)은 테스트와 동일하게 meetmate 입장,
                // 전용 설문조사(conference_id 無)는 기존대로 앱 내 상세 응답으로 분기.
                action: isTest || !!item.conference_id
                    ? 'conference'
                    : 'detail',
                isVisualDisabled: false,
            };
        }
        // ④ 종료_미응시
        return {
            badgeText: isSurvey ? t('assignment.notParticipated') : t('assignment.noStare'),
            badgeClass: 'not-submitted',
            buttonText: isSurvey ? t('assignment.closed') : t('assignment.takeTestClosed'),
            buttonClass: 'btn_light_grey',
            action: 'none',
            isVisualDisabled: false,
        };
    };
    const handlerStudentCardCTA = (item) => {
        const cardState = getStudentCardState(item);
        switch (cardState.action) {
            case 'none':
                return;
            case 'detail':
                goToDetailPage(item.id);
                return;
            case 'conference':
                if (item.conference_id) {
                    (0, funtions_1.goToConference)(item.conference_id);
                }
                return;
        }
    };
    const handlerLoadMoreCard = (nextGroup) => {
        if (isCardLoadingMore || cardData.length >= totalCount)
            return;
        setCardGroup(nextGroup);
        setIsCardLoadingMore(true);
        setPage(nextGroup - 1);
    };
    const renderCard = (item) => {
        const cardState = getStudentCardState(item);
        const progressPeriod = getProgressPeriodText(item);
        return (react_1.default.createElement("div", { className: "student-card-item", key: item.id },
            react_1.default.createElement("div", { className: "student-card-head" },
                react_1.default.createElement("span", { className: `student-card-badge ${cardState.badgeClass}` }, cardState.badgeText),
                react_1.default.createElement("span", { className: "student-card-period" }, progressPeriod)),
            react_1.default.createElement("div", { className: "student-card-title overText2" }, item.title),
            react_1.default.createElement(common_1.Button, { className: `xmd fit_btn student-card-button ${cardState.buttonClass}`, text: cardState.buttonText, onClick: () => handlerStudentCardCTA(item), styles: {
                    buttonWrap: {
                        width: '100%',
                        justifyContent: 'center',
                        cursor: cardState.action === 'none' ? 'default' : 'pointer',
                    },
                } })));
    };
    const renderTitle = (0, react_1.useMemo)(() => initLoad && (react_1.default.createElement(AssignmentTitle_1.AssignmentTitle, { isBackOffice: false, isTest: isTest, isSurvey: isSurvey, isTeacher: false, checkList: [], status: status, type: type, keyword: keyword, submitted: submitted, setStatus: setStatus, setType: setType, setKeyword: setKeyword, setSubmitted: setSubmitted })), [isTest, isSurvey, initLoad, status, type, keyword, submitted]);
    const renderEmpty = (0, react_1.useMemo)(() => (react_1.default.createElement(option_1.EmptyTable, { title: `assignment.${isSurvey ? 'survey' : isTest ? 'test' : 'assignment'}emptyData` })), [isSurvey, isTest]);
    return (react_1.default.createElement(DSTL001ListStyled_1.Container002Styled, { id: "assignment-table", className: "task-board-container assignment-table wrapper-padding", "$isDesktop": isDesktop, "$isTablet": isTablet, "$isMobile": isMobile, "$isHome": false, "$isTeacher": false, "$isTest": isTest, "$isReserve": false, "$isBackOffice": false },
        react_1.default.createElement(common_1.CardTable, { className: "student-card-list", data: cardData, totalCount: totalCount, groupSize: CARD_GROUP_SIZE, renderTitle: renderTitle, renderEmpty: hasLoadedOnce && totalCount <= 0 && renderEmpty, renderCard: renderCard, getKey: item => item.id, showMoreLabel: () => `더보기 (${cardGroup}/${Math.max(1, Math.ceil(totalCount / CARD_GROUP_SIZE))})`, handlerLoadMore: handlerLoadMoreCard, isLoadingMore: isCardLoadingMore })));
});
